import { IMPORT_SAMPLE_CASES } from './import-samples/import-samples-cases.constants';
import { IMPORT_SAMPLE_ACCOUNT } from './import-samples/import-samples-account.constant';
import { Component, OnInit, OnDestroy, Output, EventEmitter, Input, SimpleChanges, OnChanges } from "@angular/core";
import { Subject } from "rxjs";
import { CdkDragDrop, CdkDragStart, moveItemInArray } from '@angular/cdk/drag-drop';
import * as FileSaver from "file-saver";
import * as Excel from "exceljs";
import { AccountModuleId, CaseModuleId, CMOrderModuleId, ContactModuleId, InvoiceOrderModuleId, JournalModuleId, LeadModuleId, SOModuleId } from '../../constants/modules.constant';
import { IMPORT_SAMPLE_CM, IMPORT_SAMPLE_INVOICE, IMPORT_SAMPLE_JOURNAL, IMPORT_SAMPLE_SO } from './import-samples/import-samples-inventory.constant';
import { IMPORT_SAMPLE_LEAD } from './import-samples/import-samples-lead.constant';
import { IMPORT_SAMPLE_CONTACT } from './import-samples/import-samples-contact.constant';

@Component({
    selector: "app-shared-import-sample-modal",
    styleUrls: ["./shared-import-sample-modal.component.scss"],
    templateUrl: "./shared-import-sample-modal.component.html",
})
export class SharedImportSampleModalComponent implements OnInit, OnChanges, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() displayImportSample: boolean = false;
    @Input() loadFields: boolean = false;
    @Input() showOnlyRequiredSelected: boolean = false;
    @Input() selectedModule: any;
    @Input() sectionColumns: any[] = [];
    @Output() fieldsUpdated = new EventEmitter();
    @Output() dialogClosed = new EventEmitter();

    listSearchInput: string = "";
    showContent: boolean = true;
    startDrag: boolean = false;
    dialogHeader: string = "Download Sample File";
    isSelectAllSectionField: boolean = false;

    constructor(){
    }

    ngOnInit(): void {
        if(this.loadFields){
            this.dialogHeader = `${this.selectedModule?.name} Fields`;
        }
        this.getColumns();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.sectionColumns && changes.sectionColumns.currentValue){
            this.sectionColumns = changes.sectionColumns.currentValue;

            if(this.showOnlyRequiredSelected){
                this.sectionColumns.map(section=>{
                    section.fields.map(field=>{
                        field.ischecked = field.isRequired;
                        if(field?.childFields?.length>0){
                            field.childFields.map(childField=> {
                                childField.ischecked = childField.isRequired;
                            });
                        }
                    });
                });
            }
        }
    }

    //#region import module selection

    getColumns(){

    }

    // enableSectionFields($event: any, section: any){
    //     const checked = !!$event?.checked;
    //     section.fields.map(field=>{
    //         if(field?.childFields?.length){
    //             field.childFields.map(childField=> {
    //                 childField.ischecked = checked;
    //             })
    //         }else{
    //             field.ischecked = checked;
    //         }
    //     })
    // }

    enableAllSectionFields($event: any, sections: any[]) {

        const checked = !!$event?.checked;
        this.isSelectAllSectionField = checked;

        sections?.map((section) => {
            this.enableSectionFields({ checked: checked }, section);
        });
    }

    enableSectionFields($event: any, section: any) {
        const checked = !!$event?.checked;
        section.fields.map(field=>{
            if(field?.childFields?.length){
                field.childFields.map(childField=> {
                    childField.ischecked = (childField?.isDisabled && childField.ischecked) ? true : checked;
                })
            }else{
                field.ischecked = (field?.isDisabled && field.ischecked) ? true : checked;
            }
        });
    }


    cdkDragStarted(event: CdkDragStart){
        this.startDrag = true;
        this.showContent = false;
    }

    cdkDragReleased(){
        this.startDrag = false;
        this.showContent = true;
    }

    dropListSection(event: CdkDragDrop<string[]>) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }

    dropCol(event: CdkDragDrop<string[]>) {
        moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    }

    showChild(col: any): void {
        col.showChildrens = !col?.showChildrens;
    }

    toggleSection(section): void{
        section['isToogle'] = !section?.isToogle;
    }

    escapeCsvValue(value: any): string {
        // Add double quotes around the value if it contains special characters or whitespace
        if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('+') || value.includes('-'))) {
            return `"${value.replace(/"/g, '""')}"`; // Escape any double quotes within the value
        }
        return value;
    }

    downLoadExcel(type: 'csv'|'excel' = 'excel'){
        const fileName = `${this.selectedModule?.name}_Import_Sample_File_${new Date().getTime()}`;
        const selectedFields: any[] = [];
        this.sectionColumns.map(section=>{
            section.fields.map(field=>{
                if(field?.childFields?.length>0){
                    const childSelectedFields = field.childFields.filter(childField=> childField.ischecked);
                    selectedFields.push(...childSelectedFields);
                }else if(field.ischecked){
                    selectedFields.push(field);
                }
            });
        });

        let sampleFile: any[] = [];
        switch(this.selectedModule?.id){
            case AccountModuleId:
                sampleFile = IMPORT_SAMPLE_ACCOUNT;
                break;
            case LeadModuleId:
                sampleFile = IMPORT_SAMPLE_LEAD;
                break;
            case  ContactModuleId:
                sampleFile = IMPORT_SAMPLE_CONTACT;
                break;
            case CaseModuleId:
                sampleFile = IMPORT_SAMPLE_CASES;
                break;
            case SOModuleId:
                sampleFile = IMPORT_SAMPLE_SO;
                break;
            case InvoiceOrderModuleId:
                sampleFile = IMPORT_SAMPLE_INVOICE;
                break;
            case CMOrderModuleId:
                sampleFile = IMPORT_SAMPLE_CM;
                break;
            case JournalModuleId:
                sampleFile = IMPORT_SAMPLE_JOURNAL;
                break;
        }

        if(type=='csv'){
            const headers: string[] = selectedFields.map(field=>field.labelName);
            let csvContent = '';
            csvContent += headers.map(this.escapeCsvValue).join(',') + '\n';

            //Generate Sample Data
            sampleFile.map(rowData=>{
                const rowValues: string[] = selectedFields.map(field=> rowData?.[field.field]||"");
                csvContent += rowValues.map(this.escapeCsvValue).join(',') + '\n';
            })
            //Generate Sample Data End

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            FileSaver.saveAs(blob, `${fileName}.csv`);
            this.closeDialog();
        }else{
            const headers: string[] = selectedFields.map(field=> field?.isRequired ? `${field.labelName} *` :  field.labelName);
            let workbook = new Excel.Workbook();
            let worksheet = workbook.addWorksheet('Import Data');
            let headerRow: any = worksheet.addRow(headers);
            headerRow.eachCell((cell: any) => {
                const headerValue = cell._value.model.value;
                const foundData = selectedFields.find(field => (`${field.labelName} *` === headerValue));
                cell.font = {
                    bold: true,
                    color: { argb: foundData ? 'EE0909' : '' }
                };
            });

            //Generate Sample Data
            sampleFile.map(rowData=>{
                const rowValues: string[] = selectedFields.map(field=> rowData?.[field.field]||"");
                worksheet.addRow(rowValues);
            })
            //Generate Sample Data End

            workbook.xlsx.writeBuffer().then((data) => {
                let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                FileSaver.saveAs(blob, `${fileName}.xlsx`);
                this.closeDialog();
            });
        }
    }

    //#endregion

    closeDialog(){
        this.displayImportSample = false;
        this.dialogClosed.emit(true);
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
}
